// src/data/blogsData.js
// ─────────────────────────────────────────────────────────────────────────────
// BLOCK TYPES & OPTIONS
// ─────────────────────────────────────────────────────────────────────────────
//
//  { type: "p",          text: "...",          color: "default|muted|green|red|blue|yellow|purple" }
//  { type: "h2",         text: "...",          color: "default|green|red|blue|..." }
//  { type: "h3",         text: "...",          color: "default|green|red|blue|..." }
//  { type: "blockquote", text: "...",          accentColor: "default|green|red|blue|yellow|purple" }
//  { type: "list",       items: [...],         markerColor: "default|green|red|blue|yellow|purple" }
//                        -- each item can be a string OR { text: "...", color: "..." }
//  { type: "code",       text: "...",          lang: "js|bash|sql|..." (display only) }
//  { type: "image",      src: "...",           alt: "...", caption: "..." (optional),
//                        size: "sm|md|lg|full" (default "lg") }
//  { type: "callout",    text: "...",          color: "green|red|blue|yellow|purple",
//                        icon: "✦|⚠|✓|→|★" (optional) }
//  { type: "divider" }
//
// COLOR TOKENS (maps to Tailwind classes inside the renderer)
//   "default"  → text-foreground / border-foreground
//   "muted"    → text-muted-foreground
//   "green"    → text-emerald-500   / border-emerald-500   / bg-emerald-500/10
//   "red"      → text-red-500       / border-red-500       / bg-red-500/10
//   "blue"     → text-blue-500      / border-blue-500      / bg-blue-500/10
//   "yellow"   → text-yellow-400    / border-yellow-400    / bg-yellow-400/10
//   "purple"   → text-violet-500    / border-violet-500    / bg-violet-500/10
// ─────────────────────────────────────────────────────────────────────────────

export const blogsData = [
//     {
//         id: "scaling-node-microservices",
//         title: "Scaling Node.js microservices to a million requests a day",
//         excerpt:
//             "Notes from tuning a real-world financial microservice — connection pools, backpressure, caching layers and the small decisions that compound.",
//         date: "2025-03-18",
//         readTime: "9 min read",
//         category: "Backend",
//         tags: ["Node.js", "Performance", "Microservices"],
//         // Optional hero image for this post
//         heroImage: {
//             src: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1400&q=80",
//             alt: "Server infrastructure",
//         },
//         content: [
//             {
//                 type: "p",
//                 text: "When our financial microservice started processing over a million masked transactions daily, the cracks appeared fast. Response times crept up, connection pool exhaustion errors surfaced at peak hours, and our on-call rotation got very busy.",
//             },
//             {
//                 type: "callout",
//                 color: "blue",
//                 icon: "→",
//                 text: "This post covers real production changes — not benchmarks on a clean machine. All numbers are from our staging + prod environments.",
//             },
//             { type: "h2", text: "The baseline problem", color: "default" },
//             {
//                 type: "p",
//                 text: "The service was built on Node.js with Express, backed by PostgreSQL and a Redis cache. Under light load it was fine. Under 50k+ requests per hour it fell apart.",
//                 color: "default",
//             },
//             {
//                 type: "p",
//                 text: "Our PostgreSQL connection pool was sized at the default (10 connections). We were running 4 Node.js instances — 40 total connections fighting over every hot query.",
//                 color: "muted",
//             },
//             {
//                 type: "callout",
//                 color: "green",
//                 icon: "✓",
//                 text: "Fix: tuned maxConnections to Math.ceil(cpuCount * 2.5) per instance. P95 dropped 18% immediately.",
//             },
//             { type: "h2", text: "Backpressure and queue depth" },
//             {
//                 type: "p",
//                 text: "Node.js's async event loop handles concurrency beautifully — right up until you have more in-flight work than your downstream systems can absorb.",
//             },
//             {
//                 type: "blockquote",
//                 text: "Accepting a request is a promise. If you can't keep it, fail fast — don't queue forever.",
//                 accentColor: "green",
//             },
//             {
//                 type: "code",
//                 lang: "js",
//                 text: `import pLimit from "p-limit";
// import CircuitBreaker from "opossum";

// const limit = pLimit(20); // max 20 concurrent DB calls

// const breaker = new CircuitBreaker(dbQuery, {
//   timeout: 3000,
//   errorThresholdPercentage: 50,
//   resetTimeout: 10000,
// });

// export const safeQuery = (sql, params) =>
//   limit(() => breaker.fire(sql, params));`,
//             },
//             {
//                 type: "callout",
//                 color: "red",
//                 icon: "⚠",
//                 text: "Warning: error rate went up briefly after adding circuit breakers. That's expected — previously those errors were hidden as timeouts. Surface them, then fix the root cause.",
//             },
//             { type: "h2", text: "Redis caching for hot paths", color: "blue" },
//             {
//                 type: "p",
//                 text: "About 60% of read traffic was hitting the same aggregate queries — daily totals, status summaries — that changed at most once per minute.",
//             },
//             {
//                 type: "code",
//                 lang: "js",
//                 text: `const cacheKey = \`summary:\${clientId}:\${date}\`;
// const cached = await redis.get(cacheKey);
// if (cached) return JSON.parse(cached);

// const result = await db.query(summaryQuery, [clientId, date]);
// await redis.setex(cacheKey, 60, JSON.stringify(result));
// return result;`,
//             },
//             {
//                 type: "image",
//                 src: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
//                 alt: "Performance metrics dashboard",
//                 caption: "P95 latency before and after — 480ms → 112ms on the critical endpoint.",
//                 size: "lg",
//             },
//             { type: "h2", text: "Results" },
//             {
//                 type: "list",
//                 markerColor: "green",
//                 items: [
//                     { text: "Throughput: 600 req/s → 1,100 req/s", color: "green" },
//                     { text: "P95 latency: 480ms → 112ms", color: "green" },
//                     { text: "Uptime: 99.9% sustained for 6+ months", color: "green" },
//                     "Connection pool exhaustion errors: eliminated",
//                     "On-call pages related to this service: down 70%",
//                 ],
//             },
//             { type: "divider" },
//             {
//                 type: "p",
//                 text: "No single fix was the silver bullet. The connection pool tuning, backpressure controls, and caching each contributed independently — and compounded.",
//                 color: "muted",
//             },
//         ],
//     },

//     {
//         id: "postgres-query-wins",
//         title: "Five PostgreSQL query rewrites that cut our latency by 22%",
//         excerpt:
//             "A practical tour of the index strategies, window functions and explain-plan reads that made our hottest endpoints noticeably faster.",
//         date: "2025-01-09",
//         readTime: "7 min read",
//         category: "Databases",
//         tags: ["PostgreSQL", "Optimisation"],
//         heroImage: null, // no hero image for this post
//         content: [
//             {
//                 type: "p",
//                 text: "Our financial dashboard endpoint was hitting 480ms P95 under load. After a week of reading EXPLAIN (ANALYZE, BUFFERS) output, we got it to 112ms. Here are the five changes.",
//             },
//             {
//                 type: "callout",
//                 color: "yellow",
//                 icon: "✦",
//                 text: "All tests run on PostgreSQL 15 with a 10M-row transactions table. Your numbers will vary — always measure on your actual data.",
//             },
//             { type: "h2", text: "1. Correlated subquery → window function", color: "blue" },
//             {
//                 type: "p",
//                 text: "We had a correlated subquery computing a running balance per transaction row. It executed once per row — O(n²) effectively. A window function made it a single pass. 4× faster.",
//             },
//             {
//                 type: "code",
//                 lang: "sql",
//                 text: `-- Before (slow — correlated subquery)
// SELECT t.id, t.amount,
//   (SELECT SUM(amount) FROM txns t2
//    WHERE t2.account_id = t.account_id
//      AND t2.created_at <= t.created_at) AS running_total
// FROM txns t;

// -- After (fast — window function)
// SELECT id, amount,
//   SUM(amount) OVER (
//     PARTITION BY account_id
//     ORDER BY created_at
//   ) AS running_total
// FROM txns;`,
//             },
//             { type: "h2", text: "2. Partial index on status", color: "blue" },
//             {
//                 type: "p",
//                 text: "80% of queries filtered status != 'completed'. A full index on status was being ignored because 'completed' rows made up 90% of the table. A partial index on the 10% that mattered fixed it.",
//             },
//             {
//                 type: "code",
//                 lang: "sql",
//                 text: `CREATE INDEX idx_txns_active
// ON txns (status, created_at)
// WHERE status != 'completed';`,
//             },
//             {
//                 type: "callout",
//                 color: "green",
//                 icon: "✓",
//                 text: "Partial indexes are one of the most underused PostgreSQL features. If your queries consistently filter on a subset of values, use them.",
//             },
//             { type: "h2", text: "3. Covering index to avoid heap fetches", color: "blue" },
//             { type: "h2", text: "4. OR → UNION ALL", color: "blue" },
//             { type: "h2", text: "5. Per-transaction work_mem for analytics", color: "blue" },
//             {
//                 type: "blockquote",
//                 text: "EXPLAIN (ANALYZE, BUFFERS) is the most underused tool in most backend engineers' kits.",
//                 accentColor: "yellow",
//             },
//             {
//                 type: "list",
//                 markerColor: "default",
//                 items: [
//                     "Total P95 improvement: 480ms → 112ms (77% reduction)",
//                     "No schema changes, no hardware upgrades",
//                     { text: "Every fix was found by reading the query plan — not guessing", color: "muted" },
//                 ],
//             },
//         ],
//     },

//     {
//         id: "spring-boot-observability",
//         title: "Observability that actually pays off in Spring Boot services",
//         excerpt:
//             "Metrics, tracing and structured logs — a minimal but effective setup that dropped our incident resolution time by 30%.",
//         date: "2024-11-22",
//         readTime: "11 min read",
//         category: "Backend",
//         tags: ["Java", "Spring Boot", "Observability"],
//         heroImage: null,
//         content: [
//             {
//                 type: "p",
//                 text: "Observability gets talked about a lot and implemented badly even more. Here's the minimal setup that reduced our mean time to resolution by 30%.",
//             },
//             { type: "h2", text: "Structured logging with correlation IDs" },
//             {
//                 type: "p",
//                 text: "Switch from plain text logs to JSON. Add a correlation ID to every inbound request and propagate it through every log line and outbound call.",
//             },
//             {
//                 type: "code",
//                 lang: "java",
//                 text: `public class CorrelationIdFilter extends OncePerRequestFilter {
//     @Override
//     protected void doFilterInternal(HttpServletRequest req,
//                                     HttpServletResponse res,
//                                     FilterChain chain)
//             throws IOException, ServletException {
//         String id = Optional
//             .ofNullable(req.getHeader("X-Correlation-ID"))
//             .orElse(UUID.randomUUID().toString());
//         MDC.put("correlationId", id);
//         res.setHeader("X-Correlation-ID", id);
//         try { chain.doFilter(req, res); }
//         finally { MDC.clear(); }
//     }
// }`,
//             },
//             { type: "h2", text: "RED metrics on every boundary" },
//             {
//                 type: "callout",
//                 color: "blue",
//                 icon: "→",
//                 text: "Rate, Errors, Duration — track these at every service boundary. Spring Boot Actuator + Micrometer gives you most of this for free.",
//             },
//             {
//                 type: "blockquote",
//                 text: "Averages hide the pain. Your worst 1% of users define your actual reliability.",
//                 accentColor: "red",
//             },
//             {
//                 type: "list",
//                 markerColor: "blue",
//                 items: [
//                     "Structured JSON logs + correlation IDs — do this first.",
//                     "RED metrics at every boundary via Micrometer.",
//                     { text: "P95/P99 dashboards — averages lie.", color: "red" },
//                     "Alert on symptoms (error rate, latency) not causes (CPU, memory).",
//                 ],
//             },
//         ],
//     },

//     {
//         id: "aws-lambda-patterns",
//         title: "Four AWS Lambda patterns I keep reaching for",
//         excerpt:
//             "Event-driven workflows, idempotency, retries and cold-start mitigations — patterns from building an automation engine on Lambda.",
//         date: "2024-09-04",
//         readTime: "8 min read",
//         category: "Cloud",
//         tags: ["AWS", "Serverless"],
//         heroImage: null,
//         content: [
//             {
//                 type: "p",
//                 text: "After building an event-driven automation engine on AWS Lambda that processes 10,000+ tasks per day with zero lost events over six months, these are the four patterns I reach for every time.",
//             },
//             { type: "h2", text: "1. Idempotency keys — non-negotiable", color: "default" },
//             {
//                 type: "callout",
//                 color: "red",
//                 icon: "⚠",
//                 text: "Lambda retries on failure. SQS delivers at-least-once. If your function isn't idempotent, you WILL process events multiple times in production.",
//             },
//             {
//                 type: "code",
//                 lang: "js",
//                 text: `const params = {
//   TableName: "IdempotencyKeys",
//   Item: { eventId: event.id, processedAt: Date.now() },
//   ConditionExpression: "attribute_not_exists(eventId)",
// };
// try {
//   await dynamodb.put(params).promise();
// } catch (e) {
//   if (e.code === "ConditionalCheckFailedException") return; // already processed
//   throw e;
// }`,
//             },
//             { type: "h2", text: "2. Dead-letter queues on everything" },
//             {
//                 type: "callout",
//                 color: "yellow",
//                 icon: "✦",
//                 text: "Configure SQS DLQ on every Lambda trigger. Add a CloudWatch alarm when DLQ count > 0. Silent failures are the worst kind of production bug.",
//             },
//             { type: "h2", text: "3. Provisioned concurrency for latency-sensitive paths" },
//             {
//                 type: "blockquote",
//                 text: "Apply provisioned concurrency surgically — cold starts are a tax, not a crisis, for async workloads.",
//                 accentColor: "purple",
//             },
//             { type: "h2", text: "4. Structured logging with correlation IDs" },
//             {
//                 type: "list",
//                 markerColor: "green",
//                 items: [
//                     { text: "Idempotency keys — do this before anything else.", color: "green" },
//                     { text: "SQS DLQ + CloudWatch alarm on every trigger.", color: "default" },
//                     "Provisioned concurrency only on synchronous paths.",
//                     "Correlation IDs in every event payload and log line.",
//                 ],
//             },
//         ],
//     },

//     {
//         id: "ai-for-backend-engineers",
//         title: "What a backend engineer actually needs to know about AI",
//         excerpt:
//             "Cutting through the hype — the small subset of AI engineering that reliably improves backend products in 2025.",
//         date: "2024-06-17",
//         readTime: "6 min read",
//         category: "AI",
//         tags: ["AI", "Engineering"],
//         heroImage: {
//             src: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=1400&q=80",
//             alt: "AI and engineering",
//         },
//         content: [
//             {
//                 type: "p",
//                 text: "Every backend engineer is being told they need to 'learn AI'. Most of what's being recommended is either irrelevant, premature, or already abstracted away. Here's the subset that actually matters.",
//             },
//             {
//                 type: "callout",
//                 color: "purple",
//                 icon: "✦",
//                 text: "This is not an ML post. No transformers, no backprop, no CUDA. This is backend engineering with LLMs as a new type of external dependency.",
//             },
//             { type: "h2", text: "What you don't need to know", color: "muted" },
//             {
//                 type: "p",
//                 text: "Transformer internals. Fine-tuning. Running inference on your own hardware. That's ML engineering — a different discipline.",
//                 color: "muted",
//             },
//             { type: "h2", text: "Token limits and chunking", color: "default" },
//             {
//                 type: "p",
//                 text: "If you're building RAG, you need to chunk documents correctly. Too large — exceed context limits. Too small — lose context. Overlap your chunks. Use semantic chunking over fixed character counts.",
//             },
//             { type: "h2", text: "Latency is fundamentally different" },
//             {
//                 type: "callout",
//                 color: "red",
//                 icon: "⚠",
//                 text: "LLM API calls take 2–15 seconds. Never block a request thread on a synchronous LLM call in a high-throughput service. Stream or async — always.",
//             },
//             {
//                 type: "blockquote",
//                 text: "LLMs are slow, expensive, and non-deterministic. Design your backend accordingly.",
//                 accentColor: "purple",
//             },
//             { type: "h2", text: "Output validation" },
//             {
//                 type: "p",
//                 text: "Hallucination isn't a bug you fix — it's a constraint you design around. Request structured output (JSON schema). Validate before using. Build fallbacks.",
//             },
//             {
//                 type: "list",
//                 markerColor: "purple",
//                 items: [
//                     { text: "Chunking and context management for RAG.", color: "default" },
//                     { text: "Async / streaming patterns — don't block threads.", color: "default" },
//                     { text: "Cost modelling and output caching.", color: "default" },
//                     { text: "Output validation and fallbacks — treat LLM output as untrusted.", color: "red" },
//                 ],
//             },
//         ],
//     },
];

export const blogCategories = ["All", "Backend", "Databases", "Cloud", "AI"];